(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["palme-as-seen-on-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('palme-as-seen-on')) return;

    class PalmeAsSeenOn extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.paso__track');
        this.prevs = this.querySelectorAll('[data-paso-prev]');
        this.nexts = this.querySelectorAll('[data-paso-next]');
        if (!this.track) return;

        const step = () => {
          const slide = this.track.querySelector('.paso__slide');
          if (!slide) return this.track.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return slide.getBoundingClientRect().width + gap;
        };

        // Load the photos up to one screen ahead of what's showing.
        this.near = false;
        const warm = () => {
          if (!this.near) return;
          const box = this.track.getBoundingClientRect();
          this.track.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            if (img.getBoundingClientRect().left < box.right + box.width) img.loading = 'eager';
          });
        };

        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prevs.forEach((button) => (button.disabled = this.track.scrollLeft <= 2));
          this.nexts.forEach((button) => (button.disabled = this.track.scrollLeft >= max));
          this.toggleAttribute('data-static', max <= 0);
          warm();
        };

        this.prevs.forEach((button) =>
          button.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }))
        );
        this.nexts.forEach((button) =>
          button.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }))
        );
        this.track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();

        // Start loading ahead once the row is nearly on screen.
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            io.disconnect();
            this.near = true;
            warm();
          }, { rootMargin: '400px 0px' });
          io.observe(this);
        }
      }
    }

    customElements.define('palme-as-seen-on', PalmeAsSeenOn);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palme-as-seen-on-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('palme-aso-lightbox')) return;

    class PalmeAsoLightbox extends HTMLElement {
      connectedCallback() {
        // Live at the end of the page so it isn't trapped inside the product info column.
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > palme-aso-lightbox').forEach((el) => el.remove());
          document.body.appendChild(this);
          return;
        }
        if (this.bound) return;
        this.bound = true;

        this.dialog = this.querySelector('.paso-lb__dialog');
        this.media = this.querySelector('.paso-lb__media');
        this.image = this.querySelector('.paso-lb__image');
        this.caption = this.querySelector('.paso-lb__caption');
        this.prev = this.querySelector('[data-lb-prev]');
        this.next = this.querySelector('[data-lb-next]');
        this.cache = new Map();
        this.token = 0;

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-lb-close]')) this.close();
          else if (event.target.closest('[data-lb-prev]')) this.show(this.index - 1);
          else if (event.target.closest('[data-lb-next]')) this.show(this.index + 1);
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
          if (event.key === 'ArrowLeft') this.show(this.index - 1);
          if (event.key === 'ArrowRight') this.show(this.index + 1);
        });

        // Swipe left or right on the photo (phones).
        this.media.addEventListener('touchstart', (event) => {
          this.touchX = event.touches[0].clientX;
        }, { passive: true });
        this.media.addEventListener('touchend', (event) => {
          if (this.touchX == null) return;
          const dx = event.changedTouches[0].clientX - this.touchX;
          this.touchX = null;
          if (Math.abs(dx) > 40) this.show(this.index + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      open(items, index, trigger) {
        if (!items || !items.length) return;
        this.items = items;
        this.trigger = trigger || null;
        clearTimeout(this.closeTimer);
        this.hidden = false;
        document.documentElement.classList.add('paso-lb-open');
        this.show(index);
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            this.setAttribute('aria-hidden', 'false');
            this.dialog.focus({ preventScroll: true });
          })
        );
      }

      // Load a photo in the background at the size the pop-up needs. Each photo is only fetched once.
      load(item) {
        if (!item || !item.full) return null;
        let img = this.cache.get(item.full);
        if (!img) {
          img = new Image();
          img.decoding = 'async';
          if (item.srcset) {
            const width = Math.round(this.media.getBoundingClientRect().width) || 512;
            img.sizes = width + 'px';
            img.srcset = item.srcset;
          }
          img.src = item.full;
          this.cache.set(item.full, img);
        }
        return img;
      }

      show(index) {
        const count = this.items ? this.items.length : 0;
        if (!count || index < 0 || index >= count) return;
        this.index = index;
        const item = this.items[index];
        const token = ++this.token;

        // Sharp photo ready: show it. Not ready: show the small photo from the row straight away,
        // then swap in the sharp one the moment it arrives.
        const full = this.load(item);
        const useFull = () => {
          if (full && token === this.token) this.image.src = full.currentSrc || full.src;
        };
        if (!full || (full.complete && full.naturalWidth)) {
          useFull();
        } else {
          if (item.thumb) this.image.src = item.thumb;
          else this.image.removeAttribute('src');
          full.addEventListener('load', useFull, { once: true });
        }
        this.image.alt = item.alt || '';

        // Get the photos either side ready, so the arrows feel instant.
        [index + 1, index - 1, index + 2].forEach((i) => {
          if (i >= 0 && i < count) this.load(this.items[i]);
        });

        this.caption.innerHTML = '';
        item.li.querySelectorAll('.paso-pdp__name, .paso-pdp__meta, .paso-pdp__also').forEach((node) => {
          this.caption.appendChild(node.cloneNode(true));
        });

        const single = count < 2;
        this.prev.hidden = single;
        this.next.hidden = single;
        this.prev.disabled = index === 0;
        this.next.disabled = index === count - 1;
      }

      close() {
        if (this.hidden || this.getAttribute('aria-hidden') === 'true') return;
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('paso-lb-open');
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          this.hidden = true;
        }, 300);
        if (this.trigger && document.contains(this.trigger)) this.trigger.focus({ preventScroll: true });
      }
    }

    customElements.define('palme-aso-lightbox', PalmeAsoLightbox);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palme-as-seen-on-pdp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('palme-aso-pdp')) return;

    class PalmeAsoPdp extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.paso-pdp__track');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        // Arrows: move one photo along and line up on that photo's left edge (the row can stop anywhere after a free swipe).
        const go = (dir) => {
          const now = this.track.scrollLeft;
          const left = this.track.getBoundingClientRect().left;
          const edges = Array.from(this.track.querySelectorAll('.paso-pdp__item')).map((li) => li.getBoundingClientRect().left - left + now);
          let target = dir > 0 ? edges.find((x) => x > now + 4) : edges.reverse().find((x) => x < now - 4);
          if (target === undefined) target = dir > 0 ? this.track.scrollWidth : 0;
          this.track.scrollTo({ left: target, behavior: 'smooth' });
        };

        // Show arrows only when there are more photos than fit; hide the back arrow at the start and the next one at
        // the end. Only changes something when it needs to, at most once per frame while swiping.
        let queued = false;
        const update = () => {
          queued = false;
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          const atStart = this.track.scrollLeft <= 2;
          const atEnd = this.track.scrollLeft >= max;
          if (this.prev && this.prev.disabled !== atStart) this.prev.disabled = atStart;
          if (this.next && this.next.disabled !== atEnd) this.next.disabled = atEnd;
          if (this.hasAttribute('data-scrollable') !== max > 0) this.toggleAttribute('data-scrollable', max > 0);
        };
        const onScroll = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(update);
        };

        // Sit the arrows halfway down the photos. Measured when the size changes, not while swiping.
        const measure = () => {
          const media = this.track.querySelector('.paso-pdp__media');
          if (media && media.offsetHeight) {
            const mid = media.offsetHeight / 2 + 'px';
            if (mid !== this.mid) {
              this.mid = mid;
              this.style.setProperty('--paso-pdp-mid', mid);
            }
          }
          update();
        };

        if (this.prev) this.prev.addEventListener('click', () => go(-1));
        if (this.next) this.next.addEventListener('click', () => go(1));
        this.track.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', measure);
        if ('ResizeObserver' in window) new ResizeObserver(measure).observe(this.track);
        measure();

        // Load every photo in the row once it's nearly on screen, so nothing pops in when you use the arrows.
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            io.disconnect();
            this.track.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
          }, { rootMargin: '400px 0px' });
          io.observe(this);
        }

        // Tap a photo: open it larger.
        this.track.addEventListener('click', (event) => {
          const button = event.target.closest('.paso-pdp__media');
          const lightbox = document.querySelector('body > palme-aso-lightbox');
          if (!button || !lightbox || typeof lightbox.open !== 'function') return;
          const items = Array.from(this.track.querySelectorAll('.paso-pdp__item')).map((li) => {
            const media = li.querySelector('.paso-pdp__media');
            const img = media.querySelector('img');
            return {
              li,
              full: media.dataset.full,
              srcset: media.dataset.srcset || '',
              thumb: img ? img.currentSrc || '' : '',
              alt: img ? img.alt : ''
            };
          });
          lightbox.open(items, Number(button.dataset.lbIndex) || 0, button);
        });
      }
    }

    customElements.define('palme-aso-pdp', PalmeAsoPdp);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palme-cart-rewards"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('palme-cart-rewards')) return;

    // Stone only refreshes its own cart parts after a cart change, so the rewards bar refreshes itself
    // from the same updated cart HTML the theme receives.
    class PalmeCartRewards extends HTMLElement {
      connectedCallback() {
        this.event_name = `theme:cart:${this.dataset.view}:updateHtml`;
        this.onUpdate = (event) => this.update(event.detail && event.detail.section);
        window.addEventListener(this.event_name, this.onUpdate);
      }

      disconnectedCallback() {
        window.removeEventListener(this.event_name, this.onUpdate);
      }

      update(html) {
        if (typeof html !== 'string') return;

        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(`palme-cart-rewards[data-view="${this.dataset.view}"]`);

        if (!fresh) {
          this.hidden = true;
          return;
        }

        const old_fills = this.querySelectorAll('.palme-rewards--fill');
        const new_fills = fresh.querySelectorAll('.palme-rewards--fill');

        if (old_fills.length !== new_fills.length || this.dataset.mode !== fresh.dataset.mode) {
          this.innerHTML = fresh.innerHTML;
          this.setAttribute('style', fresh.getAttribute('style') || '');
        } else {
          // Keep the existing bars so the fill animates to its new length.
          new_fills.forEach((fill, index) => {
            old_fills[index].style.setProperty('--palme-fill', fill.style.getPropertyValue('--palme-fill'));
            old_fills[index].parentElement.dataset.reached = fill.parentElement.dataset.reached;
          });

          const track = this.querySelector('.palme-rewards--track');
          const new_track = fresh.querySelector('.palme-rewards--track');
          ['aria-valuenow', 'aria-valuetext'].forEach((name) => track.setAttribute(name, new_track.getAttribute(name)));

          this.querySelector('.palme-rewards--message').innerHTML = fresh.querySelector('.palme-rewards--message').innerHTML;

          // The row of reward names only exists when there are 2 or 3 rewards.
          const tiers = this.querySelector('.palme-rewards--tiers');
          const new_tiers = fresh.querySelector('.palme-rewards--tiers');
          if (tiers && new_tiers) tiers.replaceWith(new_tiers);
        }

        this.dataset.mode = fresh.dataset.mode;
        this.dataset.complete = fresh.dataset.complete;
        this.hidden = fresh.hidden;
      }
    }

    customElements.define('palme-cart-rewards', PalmeCartRewards);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palme-cart-upsells"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('palme-cart-upsells')) return;

    // Stone only refreshes its own cart parts after a cart change, so the upsells refresh themselves
    // from the same updated cart HTML the theme receives.
    class PalmeCartUpsells extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.event_name = `theme:cart:${this.dataset.view}:updateHtml`;
        this.onUpdate = (event) => this.update(event.detail && event.detail.section);
        this.onOutside = (event) => {
          if (!event.target.closest || !event.target.closest('.palme-upsells--picker')) this.closePickers();
        };
        window.addEventListener(this.event_name, this.onUpdate);
        document.addEventListener('click', this.onOutside);
        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('keydown', (event) => this.onKeydown(event));
      }

      disconnectedCallback() {
        window.removeEventListener(this.event_name, this.onUpdate);
        document.removeEventListener('click', this.onOutside);
        this.dataset.bound = 'false';
      }

      update(html) {
        if (typeof html !== 'string') return;
        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(`palme-cart-upsells[data-view="${this.dataset.view}"]`);

        this.innerHTML = fresh ? fresh.innerHTML : '';
        this.hidden = fresh ? fresh.hidden : true;
      }

      // Dropdown lists (colour picker, and the size list that ADD opens)
      openPicker(picker, focus_option) {
        this.closePickers(picker);
        const list = picker.querySelector('.palme-upsells--options');
        list.hidden = false;
        picker.setAttribute('data-open', '');
        picker.querySelector('[data-picker-toggle]').setAttribute('aria-expanded', 'true');
        if (focus_option) {
          const target = list.querySelector('[aria-selected="true"]:not([aria-disabled="true"])') || this.enabledOptions(list)[0];
          if (target) target.focus();
        }
      }

      closePickers(except) {
        this.querySelectorAll('.palme-upsells--picker[data-open]').forEach((picker) => {
          if (picker === except) return;
          picker.removeAttribute('data-open');
          picker.querySelector('.palme-upsells--options').hidden = true;
          picker.querySelector('[data-picker-toggle]').setAttribute('aria-expanded', 'false');
        });
      }

      enabledOptions(list) {
        return Array.from(list.querySelectorAll('.palme-upsells--option:not([aria-disabled="true"])'));
      }

      chooseOption(option) {
        if (!option || option.getAttribute('aria-disabled') === 'true') return;
        const picker = option.closest('.palme-upsells--picker');
        const item = option.closest('.palme-upsells--item');

        picker.querySelectorAll('.palme-upsells--option').forEach((other) => other.setAttribute('aria-selected', 'false'));
        option.setAttribute('aria-selected', 'true');
        this.closePickers();

        // Size list opened from ADD: choosing a size adds it straight away.
        if (picker.hasAttribute('data-add-on-choose')) {
          this.addToCart(picker.querySelector('.palme-upsells--add'), option.dataset.id);
          return;
        }

        // Colour (or other) picker: update the choice, then ADD adds it.
        picker.querySelector('.palme-upsells--picker-value').textContent = option.dataset.title;
        item.querySelector('.palme-upsells--add').dataset.id = option.dataset.id;
        const price = item.querySelector('[data-palme-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        picker.querySelector('[data-picker-toggle]').focus();
      }

      onKeydown(event) {
        const toggle = event.target.closest('[data-picker-toggle]');
        const option = event.target.closest('.palme-upsells--option');
        if (!toggle && !option) return;
        const picker = event.target.closest('.palme-upsells--picker');

        if (toggle && ['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
          event.preventDefault();
          this.openPicker(picker, true);
          return;
        }

        if (option) {
          const options = this.enabledOptions(option.parentElement);
          const index = options.indexOf(option);
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            (options[index + 1] || options[0]).focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            (options[index - 1] || options[options.length - 1]).focus();
          } else if (event.key === 'Home') {
            event.preventDefault();
            options[0].focus();
          } else if (event.key === 'End') {
            event.preventDefault();
            options[options.length - 1].focus();
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.chooseOption(option);
          } else if (event.key === 'Escape') {
            event.preventDefault();
            this.closePickers();
            picker.querySelector('[data-picker-toggle]').focus();
          } else if (event.key === 'Tab') {
            this.closePickers();
          }
        }
      }

      onClick(event) {
        const toggle = event.target.closest('[data-picker-toggle]');
        if (toggle) {
          event.preventDefault();
          const picker = toggle.closest('.palme-upsells--picker');
          if (picker.hasAttribute('data-open')) this.closePickers();
          else this.openPicker(picker, false);
          return;
        }

        const option = event.target.closest('.palme-upsells--option');
        if (option) {
          event.preventDefault();
          this.chooseOption(option);
          return;
        }

        const button = event.target.closest('.palme-upsells--add');
        if (!button) return;
        event.preventDefault();
        this.addToCart(button, button.dataset.id);
      }

      async addToCart(button, id) {
        if (!button || !id || button.getAttribute('aria-busy') === 'true') return;

        button.setAttribute('aria-busy', 'true');
        button.setAttribute('data-state', 'adding');

        try {
          const { Cart } = await import('@troop-themes/main');
          await Cart.addItems(
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(id), quantity: 1, properties: { _upsell: 'cart' } }],
                sections: Cart.sections,
              }),
            },
            false
          );
        } catch (error) {
          console.error('PALME cart upsell add failed', error);
          button.setAttribute('data-state', 'error');
          setTimeout(() => button.removeAttribute('data-state'), 2000);
        } finally {
          if (button.getAttribute('data-state') === 'adding') button.removeAttribute('data-state');
          button.setAttribute('aria-busy', 'false');
        }
      }
    }

    customElements.define('palme-cart-upsells', PalmeCartUpsells);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palme-size-quick-add"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('palme-size-add')) return;

    class PalmeSizeAdd extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.addEventListener('click', (event) => this.onClick(event));

        if (this.dataset.mode === 'matrix') this.setupMatrix();
        if (this.dataset.preview === 'true') this.setupPreview();
      }

      // Colour-only products: hovering (or tabbing to) a colour name shows the card photo in that colour.
      setupPreview() {
        this.card = this.closest('.product-card--root');
        if (!this.card || this.card.getAttribute('data-swatch-option-position') !== this.dataset.optionPosition) return;

        const preview = (event) => {
          const button = event.target.closest && event.target.closest('.palme-size-add--button');
          if (button && this.contains(button)) this.previewChoice(button.dataset.value);
        };
        const endPreview = () => this.card.removeAttribute('data-palme-preview');

        this.addEventListener('mouseover', preview);
        this.addEventListener('focusin', preview);

        // Keep showing the previewed colour while the pointer stays on the photo, then hand back to the theme.
        const wrapper = this.closest('.product-card--image-wrapper');
        if (wrapper) wrapper.addEventListener('mouseleave', endPreview);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget) && !(wrapper && wrapper.matches(':hover'))) endPreview();
        });
      }

      previewChoice(value) {
        if (!value) return;
        const inputs = Array.from(this.card.querySelectorAll('.swatch--input')).filter((input) => input.value === value);
        if (!inputs.length) return;

        this.card.setAttribute('data-palme-preview', '');
        if (inputs[0].checked) return;

        // Select the matching swatch(es) so the theme swaps the photo and links, and the swatch row stays in sync.
        inputs.forEach((input) => {
          input.checked = true;
        });
        inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
      }

      setupMatrix() {
        this.size_index = parseInt(this.dataset.sizeIndex, 10);
        this.choice_index = parseInt(this.dataset.choiceIndex, 10);
        this.card = this.closest('.product-card--root');

        try {
          const data = this.querySelector('[data-palme-variants]');
          this.variants = data ? JSON.parse(data.textContent) : [];
        } catch (error) {
          this.variants = [];
          console.error('PALME quick add: could not read variants', error);
        }

        this.current_choice = this.dataset.choice || null;

        // Sizes follow the colour swatch the shopper picks under the card.
        const swatch_position = this.card?.getAttribute('data-swatch-option-position');
        this.swatches_match = swatch_position && parseInt(swatch_position, 10) === parseInt(this.dataset.choicePosition, 10);
        if (this.card && this.swatches_match) {
          this.card.addEventListener('change', (event) => {
            const input = event.target;
            if (input && input.matches && input.matches('.swatch--input') && input.checked) {
              this.selectChoice(input.value);
            }
          });
        }
      }

      selectChoice(value) {
        if (!value || value === this.current_choice) return;
        this.current_choice = value;
        this.dataset.choice = value;

        this.querySelectorAll('.palme-size-add--button').forEach((button) => {
          const variant = this.variants.find(
            (item) => item.options[this.choice_index] === value && item.options[this.size_index] === button.dataset.value
          );

          if (variant) {
            button.dataset.id = variant.id;
            button.dataset.management = variant.management || '';
            button.dataset.policy = variant.policy || '';
            button.dataset.quantity = variant.quantity;
          } else {
            delete button.dataset.id;
          }

          const available = Boolean(variant && variant.available);
          button.disabled = !available;
          button.setAttribute(
            'aria-label',
            available ? `Add size ${button.dataset.value} to ${this.dataset.cartLabel || 'cart'}` : `Size ${button.dataset.value} sold out`
          );
        });
      }

      async onClick(event) {
        // The bar sits inside the card's image link, so stop clicks from navigating.
        event.preventDefault();
        event.stopPropagation();

        const button = event.target.closest('.palme-size-add--button');
        if (!button || button.disabled || !button.dataset.id || this.getAttribute('aria-busy') === 'true') return;

        this.setAttribute('aria-busy', 'true');
        button.setAttribute('data-state', 'adding');

        try {
          const { Cart, Utils } = await import('@troop-themes/main');
          if (Utils && !Utils.getQuantity(button.dataset.id, button.dataset, 1)) return;

          await Cart.addItems(
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(button.dataset.id), quantity: 1 }],
                sections: Cart.sections,
              }),
            },
            button
          );

          button.setAttribute('data-state', 'added');
          setTimeout(() => button.removeAttribute('data-state'), 1500);
        } catch (error) {
          console.error('PALME quick add failed', error);
          button.setAttribute('data-state', 'error');
          setTimeout(() => button.removeAttribute('data-state'), 2000);
        } finally {
          if (button.getAttribute('data-state') === 'adding') button.removeAttribute('data-state');
          this.setAttribute('aria-busy', 'false');
        }
      }
    }

    customElements.define('palme-size-add', PalmeSizeAdd);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palme-size-script"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('palme-size-panel')) return;

    // Becomes true once the shopper picks a size themselves (main form or panel).
    window.PALME_SIZE = window.PALME_SIZE || { chosen: false };

    const optionFor = (element) => (element ? element.closest('.product-options--option') : null);

    const sizeContainerIn = (scope) =>
      scope ? scope.querySelector('product-options-element[data-main-product="true"] [data-palme-size-option]') : null;

    const setValueLabel = (option, value) => {
      const label = option ? option.querySelector('.palme-size-value') : null;
      if (label) label.textContent = value ? `: ${value}` : '';
    };

    const hideMessage = (option) => {
      const message = option ? option.querySelector('.palme-size-msg') : null;
      if (message) message.hidden = true;
    };

    // The theme ticks the first size by default. Clear it so shoppers pick their own.
    const clearSize = (container) => {
      container.querySelectorAll('.radios--input').forEach((input) => {
        input.checked = false;
      });
      setValueLabel(optionFor(container), '');
    };

    const missingSize = (form) => {
      const container = sizeContainerIn(form);
      if (!container) return null;
      if (window.PALME_SIZE.chosen && container.querySelector('.radios--input:checked')) return null;
      return container;
    };

    const askForSize = (container) => {
      const option = optionFor(container);
      if (!option) return;
      const message = option.querySelector('.palme-size-msg');
      if (message) message.hidden = false;
      const rect = option.getBoundingClientRect();
      if (rect.top < 100 || rect.bottom > window.innerHeight - 100) {
        option.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    // Runs each time the theme renders the size option (page load and after option changes).
    class PalmeSizeSync extends HTMLElement {
      connectedCallback() {
        const option = optionFor(this);
        const container = option ? option.querySelector('[data-palme-size-option]') : null;
        if (!container) return;
        if (!window.PALME_SIZE.chosen) clearSize(container);
        option.setAttribute('data-palme-ready', '');
      }
    }

    customElements.define('palme-size-sync', PalmeSizeSync);

    // Shopper picked a size in the main form.
    document.addEventListener(
      'change',
      (event) => {
        const input = event.target;
        if (!input || !input.matches || !input.matches('[data-palme-size-option] .radios--input')) return;
        window.PALME_SIZE.chosen = true;
        const option = optionFor(input);
        setValueLabel(option, input.value);
        hideMessage(option);
      },
      true
    );

    // Add to bag with no size picked: stop it and ask for a size.
    document.addEventListener(
      'submit',
      (event) => {
        const container = missingSize(event.target);
        if (!container) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        askForSize(container);
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest && event.target.closest('.product-buy-buttons--buy-now, .palme-sticky-select');
        if (!button) return;

        if (button.matches('.palme-sticky-select')) {
          event.preventDefault();
          const panel = document.querySelector('body > palme-size-panel');
          if (panel) panel.open(button);
          return;
        }

        const container = missingSize(button.closest('form'));
        if (!container) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        askForSize(container);
      },
      true
    );

    class PalmeSizePanel extends HTMLElement {
      connectedCallback() {
        // Move to the end of the page so the panel isn't trapped inside the sticky bar.
        if (this.parentElement !== document.body) {
          this.form = this.closest('form');
          document.querySelectorAll('body > palme-size-panel').forEach((panel) => panel.remove());
          document.body.appendChild(this);
          return;
        }

        if (this.bound) return;
        this.bound = true;

        this.size_index = parseInt(this.dataset.sizeIndex, 10) || 0;
        try {
          const data = this.querySelector('[data-palme-variants]');
          this.variants = data ? JSON.parse(data.textContent) : [];
        } catch (error) {
          this.variants = [];
          console.error('PALME size panel: could not read variants', error);
        }

        this.sheet = this.querySelector('.palme-size-panel--sheet');
        this.guide_button = this.querySelector('.palme-size-panel--guide');

        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
      }

      get container() {
        return sizeContainerIn(this.form);
      }

      get input() {
        return this.form ? this.form.querySelector('.product-buy-buttons--input') : null;
      }

      sizeGuideTrigger() {
        if (!this.form) return null;
        return this.form.querySelector('.palme-size-guide, .product-size-guide--root button, .product-size-guide--root a');
      }

      variantFor(size) {
        const current_id = Number(this.input ? this.input.value : 0);
        const current = this.variants.find((variant) => variant.id === current_id) || this.variants[0];
        if (!current) return null;
        return (
          this.variants.find((variant) =>
            variant.options.every((value, index) =>
              index === this.size_index ? value === size : value === current.options[index]
            )
          ) || null
        );
      }

      refresh() {
        const container = this.container;
        const checked = container && window.PALME_SIZE.chosen ? container.querySelector('.radios--input:checked') : null;
        const cart_label = this.dataset.cartLabel || 'cart';

        this.querySelectorAll('.palme-size-panel--size').forEach((button) => {
          const variant = this.variantFor(button.dataset.value);
          const available = Boolean(variant && variant.available);

          if (variant) {
            button.dataset.id = variant.id;
            button.dataset.management = variant.management || '';
            button.dataset.policy = variant.policy || '';
            button.dataset.quantity = variant.quantity;
          } else {
            delete button.dataset.id;
          }

          button.disabled = !available;
          button.setAttribute('aria-pressed', checked && checked.value === button.dataset.value ? 'true' : 'false');
          button.setAttribute(
            'aria-label',
            available ? `Add size ${button.dataset.value} to ${cart_label}` : `Size ${button.dataset.value} sold out`
          );
        });

        if (this.guide_button) this.guide_button.hidden = !this.sizeGuideTrigger();
      }

      open(trigger) {
        this.trigger = trigger || null;
        clearTimeout(this.close_timer);
        this.refresh();
        this.hidden = false;
        document.documentElement.classList.add('palme-size-panel-open');
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            this.setAttribute('aria-hidden', 'false');
            // Focus the panel itself (not a size) so no size looks picked before the shopper taps one.
            if (this.sheet) this.sheet.focus({ preventScroll: true });
          })
        );
      }

      close() {
        if (this.hidden || this.getAttribute('aria-hidden') === 'true') return;
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('palme-size-panel-open');
        clearTimeout(this.close_timer);
        this.close_timer = setTimeout(() => {
          this.hidden = true;
        }, 300);
      }

      onClick(event) {
        if (event.target.closest('[data-palme-close]')) {
          this.close();
          return;
        }

        if (event.target.closest('.palme-size-panel--guide')) {
          const guide = this.sizeGuideTrigger();
          this.close();
          if (guide) setTimeout(() => guide.click(), 320);
          return;
        }

        const button = event.target.closest('.palme-size-panel--size');
        if (button) this.addSize(button);
      }

      async addSize(button) {
        if (button.disabled || !button.dataset.id || this.busy) return;
        this.busy = true;
        button.setAttribute('data-state', 'adding');

        // Pick the same size in the main form so the page matches what's in the bag.
        window.PALME_SIZE.chosen = true;
        const container = this.container;
        const input = container
          ? Array.from(container.querySelectorAll('.radios--input')).find((item) => item.value === button.dataset.value)
          : null;
        if (input && !input.checked) {
          input.click();
        } else if (input) {
          setValueLabel(optionFor(input), input.value);
          hideMessage(optionFor(input));
        }

        try {
          const { Cart, Utils } = await import('@troop-themes/main');
          if (Utils && !Utils.getQuantity(button.dataset.id, button.dataset, 1)) return;

          this.close();
          await Cart.addItems(
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(button.dataset.id), quantity: 1 }],
                sections: Cart.sections,
              }),
            },
            button
          );
        } catch (error) {
          console.error('PALME size panel: add to bag failed', error);
        } finally {
          button.removeAttribute('data-state');
          this.busy = false;
        }
      }
    }

    customElements.define('palme-size-panel', PalmeSizePanel);
  })();
  } catch(e) { console.error(e); }
})();

})();
